/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import moment from 'moment';
import * as types from './types';

// The API serializes decimal chart values as strings (Rails renders BigDecimal
// as JSON strings), and Chartist needs numbers to size bars and pie slices.
// Coerce every series value to a Number, handling both the bar shape
// (series: [[...]]) and the pie shape (series: [...]).
function numericSeries(chart) {
  if (!chart || !Array.isArray(chart.series)) return chart;
  const series = chart.series.map(value => (
    Array.isArray(value) ? value.map(Number) : Number(value)
  ));
  return { ...chart, series };
}

export const state = {
  summary: [],
  weeklySchedule: {
    days: [],
    valids: [0, 0, 0, 0, 0, 0],
    canceld: [0, 0, 0, 0, 0, 0],
  },
  showWeeklySchedule: false,
  billingChart: { labels: [], values: [] },
  averageTicket: [],
  paymentKind: [],
  loadingData: false,
  brandChart: false,
  chartsBeginDate: moment()
    .startOf('week')
    .format('YYYY-M-D')
    .toString(),
  chartsEndDate: moment()
    .endOf('week')
    .format('YYYY-M-D')
    .toString(),
  updateCharts: false,
  chartScope: 'weeky',
  wallet: {},
  isLoading: false,
  successStatus: false,
  errorStatus: false,
};

export const mutations = {
  [types.CHART_SCOPE](state, scope) {
    state.chartScope = scope;
  },
  [types.SUMMARY](state, summary) {
    state.summary = summary;
  },
  [types.SHOW_SUMMARY](state, showSummary) {
    state.showSummary = showSummary;
  },
  [types.WEEKLY_SCHEDULE](state, weeklySchedule) {
    state.weeklySchedule = weeklySchedule;
  },
  [types.SHOW_WEEKLY_SCHEDULE](state, showWeeklySchedule) {
    state.showWeeklySchedule = showWeeklySchedule;
  },
  [types.BILLING_CHART](state, billingChart) {
    state.billingChart = numericSeries(billingChart);
  },
  [types.SHOW_BILLING_CHART](state, showBillingChart) {
    state.showBillingChart = showBillingChart;
  },
  [types.AVERAGE_TICKET](state, averageTicket) {
    state.averageTicket = numericSeries(averageTicket);
  },
  [types.SHOW_AVERAGE_TICKET](state, showAverageTicket) {
    state.showAverageTicket = showAverageTicket;
  },
  [types.PAYMENT_KIND](state, paymentKind) {
    state.paymentKind = numericSeries(paymentKind);
  },
  [types.SHOW_PAYMENT_KIND](state, showPaymentKind) {
    state.showPaymentKind = showPaymentKind;
  },
  [types.LOADING_DATA](state, status) {
    state.loadingData = status;
  },
  [types.BRAND_CHART](state, status) {
    state.brandChart = numericSeries(status);
  },
  [types.SHOW_BRAND_CHART](state, showBrandChart) {
    state.showBrandChart = showBrandChart;
  },
  [types.CHARTS_BEGIN_DATE](state, date) {
    state.chartsBeginDate = date;
  },
  [types.CHARTS_END_DATE](state, date) {
    state.chartsEndDate = date;
  },
  [types.UPDATE_CHARTS](state, status) {
    state.updateCharts = status;
  },
  [types.WALLET](state, wallet) {
    state.wallet = wallet;
  },
  [types.IS_LOADING](state, isLoading) {
    state.isLoading = isLoading;
  },
  [types.LOAD](state, loading) {
    state.isLoading = loading;
  },
  [types.GET_SUMMARY](state, summary) {
    state.summary = summary;
  },
  [types.GET_WEEKLY_SCHEDULE](state, weeklySchedule) {
    state.weeklySchedule = weeklySchedule;
  },
  [types.GET_BILLING_CHART](state, billingChart) {
    state.billingChart = numericSeries(billingChart);
  },
  [types.GET_AVERAGE_TICKET](state, averageTicket) {
    state.averageTicket = numericSeries(averageTicket);
  },
  [types.GET_PAYMENT_KIND](state, paymentKind) {
    state.paymentKind = numericSeries(paymentKind);
  },
  [types.GET_BRAND_CHART](state, brandChart) {
    state.brandChart = numericSeries(brandChart);
  },
  [types.GET_WALLET](state, wallet) {
    state.wallet = wallet;
  },
  [types.SUCCESS_STATUS](state, successStatus) {
    state.successStatus = successStatus;
  },
  [types.ERROR_STATUS](state, errorStatus) {
    state.errorStatus = errorStatus;
  },
};
